export default {
  Fleet_Phase3_Other_mKWz: 'Outros',
  Fleet_Phase2_Unable_to_ZEyJ:
    'Não foi possível enviar o convite. O carro já está vinculado a outro(a) motorista',
  Fleet_Phase1_Refresh_successfully_sWTn:
    'Status do carro atualizado. Seu carro será mostrado para mais motoristas',
  Fleet_NewPaymentFlow__GUTP: 'Cobrança única',
  Fleet_NewPaymentFlow__NhvB:
    'Valor: {{Price}}. Início da cobrança: {{begin_datetime}}. Frequência: {{Frequency}}.',
  Fleet_Phase3__eugX: 'Insira o endereço detalhado',
  Fleet_Phase1_My_information_gZpd: 'Meu perfil',
  Fleet_Phase1_Management_laKS: 'Gerenciamento',
  Fleet_Phase2_Unable_to_DjsM: 'Não foi possível enviar o convite. Tente novamente mais tarde.',
  Fleet_Phase2_Not_read_oNht: 'Não lido',
  Fleet_Phase2_Invitation_binding_pNPg: 'Convidar',
  Fleet_NewPaymentFlow__qyoQ:
    '{{Expenses_type}} serão deduzidos automaticamente de sua Carteira. Frequência: {{Frequency}}.',
  Fleet_Phase3__HBGE: 'Pesquisar endereço',
  Fleet_Phase1__day_TSlN: '{{day_num}} dia(s)',
  Fleet_Phase2_Here_is_UUpu: 'Veja meu currículo',
  Fleet_Phase1_Please_select_sHdy: 'Selecione pelo menos uma opção',
  Fleet_Phase3__YASB: 'Detalhes do endereço',
  Fleet_Phase1_Completed_lnTq: 'Preenchido',
  Fleet_Phase1_Select_from_vFPP: 'Selecionar da galeria',
  Fleet_Phase2_Invitation_accepted_jUWV: 'Convite aceito',
  Fleet_NewPaymentFlow_TSCH_mgfl:
    'Você precisará receber o aluguel e demais cobranças do motorista manualmente',
  Fleet_6_Approved_iJNK: 'Aprovado',
  Fleet_Phase2_Select_a_IWnZ: 'Selecione um carro',
  Fleet_Phase3__NQtB: 'Não aprovado',
  Fleet_Phase1_Want_FfcG: 'Solicitado',
  Fleet_NewPaymentFlow_svTo_tbpj:
    'Para alterar o método de recebimento, acesse Meu perfil > Configurações',
  Fleet_Phase3_When_it_VfVv:
    'Se ativada, os donos das frotas poderão visualizar suas informações e contatá-lo; se desativada, não poderão.',
  Fleet_Phase1_Vehicle_Information_GKvX: 'Perfil do carro',
  Fleet_Phase1_Near_wiMy: 'Por perto',
  Fleet_replenish__AsrC: 'Insira o apelido da frota',
  Fleet_Phase2_Unable_to_rFbW: 'Não foi possível enviar o convite. Você já convidou o(a) motorista',
  Fleet_Phase3_Please_fill_TwPJ: 'Insira um tipo de taxa único',
  Fleet_NewPaymentFlow__JGoj: 'Método de recebimento',
  Fleet_Phase3_Cancel_lhJc: 'Cancelar',
  Fleet_Phase2_Sent_successfully_VMHB: 'Enviado com sucesso',
  Fleet_Phase1_Unfilled_information_shzk: 'Preencha os campos obrigatórios',
  Fleet_Phase1_Refresh_vehicle_dBKn: 'Atualizar o status do carro para ter mais acessos',
  Fleet_Phase1_Petrol_xPTk: 'Gasolina',
  Fleet_NewPaymentFlow__Wzlo: 'Configurar o aluguel e outras cobranças',
  Fleet_MatchingTool_Loading_ingu: 'Carregando',
  Fleet_Phase1_Select_the_TBEO: 'Selecione a primeira data disponível',
  Fleet_Phase1_Pick_up_Fzqt: 'Endereço de retirada do carro',
  Fleet_Phase3_Maintenance_costs_Arun: 'Taxa de manutenção',
  Fleet_Phase3_Looking_for_mjCy: 'Pesquisar',
  Fleet_Phase2_Go_and_TKGq: 'Entrar agora',
  Fleet_NewPaymentFlow_lHPn_FNIg: 'Atribua um nome a sua cobrança',
  Fleet_Phase3_Fill_in_AwVF: 'Fale sobre você e os serviços prestados',
  Fleet_Phase3_Handling_address_Kuoh: 'Endereço de retirada do carro',
  Fleet_Phase1_Successfully_removed_Kfwm: 'Removido com sucesso',
  Fleet_Phase3_To_protect_LYnV:
    'Para proteger sua privacidade, um número virtual será usado para esta chamada. Use {{phone_num}}.',
  Fleet_Phase2_Delete_OMUs: 'Remover',
  Fleet_Phase2_You_have_VdTt: 'Convite aceito. Fale com a frota para alugar um carro',
  Fleet_Phase1_Successful_collection_cgRX: 'Adicionado aos favoritos',
  Fleet_Phase3_Allowing_for_dpCi: 'Tornar minhas informações públicas',
  GDriver_Name_99_mpNh: '99',
  Fleet_Phase1_Driving_age_CGrZ: 'Experiência como motorista',
  Fleet_Phase1_Recommended_JWJE: 'Recomendado',
  Fleet_Phase1_Yes_KnFJ: 'Sim',
  Fleet_replenish__Nkhy: 'Não foi possível adicionar',
  Fleet_Phase1_There_are_TYqj: 'Ache motoristas qualificados',
  Fleet_Phase2_Waiting_for_CtmY: 'Aguardando a resposta do motorista',
  Fleet_Phase1_Select_the_arPR: 'Selecionar imagem padrão',
  Fleet_Phase2_Unable_to_mzyp: 'Não foi possível aceitar o convite. Outra frota já adicionou você',
  Fleet_Phase3__xiYg: 'Baixar aplicativo {{app_name}}',
  Fleet_Phase1_Edit_bifa: 'Editar',
  Fleet_Phase2_Confirmation_Amgz: 'Confirmar',
  Fleet_Phase1_Inactive_vehicles_oKjt: 'Ocioso',
  Fleet_Phase3__RlYg: 'A imagem não atende aos requisitos. Envie a foto real do carro',
  Fleet_Phase1_Vehicle_market_bycj: 'Encontrar veículos',
  Fleet_Phase1_You_modified_ugEp: 'Suas edições não foram salvas. Tem certeza que deseja sair?',
  Fleet_Phase2_The_message_dvIE: 'Mensagem muito longa. Tente reescrevê-la',
  Fleet_Phase1_Types_of_Dcxe: 'Serviços disponíveis',
  Fleet_Phase3__sjZr: 'Ativar agora',
  Fleet_Phase2_Open_message_BjYw:
    'Para receber mensagens e as últimas novidades, ative as permissões de notificação',
  Fleet_Phase2_Sending_vehicles_VpWK: 'Enviar carro',
  Fleet_NewPaymentFlow__GCoA: 'Data de ativação',
  Fleet_Phase1_On_the_Zuml: 'Adicionado',
  Fleet_Phase1_Recommended_tZZU: 'Recomendado',
  Fleet_Phase3_Looking_for_VBig: 'Pesquisar',
  Fleet_Phase1_Countless_counts_rEma: 'Sem resultados por enquanto',
  Fleet_Phase1_Open_the_mLYO:
    'Em Configurações>Privacidade>Serviços de Localização, permita que a frota {{app_name}} use a localização',
  Fleet_Phase3_Select_KUZn: 'Destaques',
  Fleet_Phase3_The_driver_lmIm: 'Os motoristas entrarão em contato por este número',
  Fleet_Phase1_Please_enter_kMFd: 'Insira o número do seu celular',
  Fleet_Phase2_More_features_rGBL: 'Toque aqui para ver mais recursos',
  Fleet_deactivation_rxsN_avVX: 'Este carro foi removido',
  Fleet_Phase1_Vehicter_vehicles_KaSk: 'Adicionar carro',
  Fleet_Phase1_Fill_in_kRws:
    'Insira suas informações pessoais para que a Frota saiba mais sobre você e entre em contato',
  'kfcommon-fe-i18n---common': {
    inpPlease: 'Complete'
  },
  Fleet_EContract_Email_mdfN: 'E-mail',
  Fleet_Phase1_Later_aaAa: 'Talvez depois',
  Fleet_Resdesign_Enter_email_cylU: 'Insira o e-mail',
  Fleet_Phase1_Management_Kglv: 'Gerenciamento',
  Fleet_Phase1_Driver_Market_lUUD: 'Encontrar motoristas',
  Fleet_Phase3_Add_pickup_rHID: 'Inserir endereço',
  Fleet_Phase1_The_earliest_BMcv: 'Próximo horário disponível',
  Fleet_FleetRecommendation_Enter_the_Ykpv: 'Insira um valor válido',
  Fleet_Phase1_Vehicter_vehicles_cgyn: 'Adicionar carro',
  Fleet_Phase1_Editing_your_VLmr: 'Editar currículo',
  Fleet_Phase1_Add_a_ZZNX: 'Adicionar novo carro',
  Fleet_Phase1_Lower_vehicle_gEAa: 'Remover carro',
  Fleet_Phase1_Are_mileage_hsVk: 'Há uma quilometragem máxima?',
  Fleet_Phase1_Add_other_TKWp: 'Adicionar outras tarifas únicas',
  Fleet_NewPaymentFlow__ZQOF: 'Próximo',
  Fleet_Phase2_Invitation_expired_IedS: 'Convite expirado',
  Fleet_Phase1_The_driver_Ktpo:
    'Os motoristas vão ligar para você por um número virtual, sem ver seu número real',
  Fleet_Phase2_You_might_PnzM: 'Talvez você queira',
  Fleet_Phase1_Enter_the_CVAP: 'Insira a quilometragem do veículo',
  Fleet_Phase2_Cancel_UgrT: 'Cancelar',
  Fleet_NewPaymentFlow__AMrP:
    'Você precisará receber o aluguel e demais cobranças do motorista manualmente',
  Fleet_Phase2_Your_resume_VFPE: 'Preencha seu currículo',
  Fleet_Phase1_Do_you_jEQf: 'Você tem uma vaga de garagem?',
  Fleet_Phase1_Open_Location_yZxu: 'Ative as permissões de localização',
  Fleet_deactivation_ZMOT_xRGi: 'Estes carros foram removidos',
  Fleet_Phase2__Invite_AtyZ: '[Convidou você para entrar na frota]',
  Fleet_Phase1_Automatic_file_EBVQ: 'Automático',
  Fleet_0303_Fleet_WorkRegime_Withdrawal_oCRI: 'Resgate do motorista parceiro',
  Fleet_Phase1_Waiting_for_hAcD: 'Não foi adicionado ainda',
  Fleet_Mgt_Pull_down_YzpV: 'Arraste para atualizar',
  Fleet_Phase1_Cities_with_FYWy: 'Cidade de operação',
  Fleet_NewPaymentFlow__TkSG: 'Falar com o(a) locador(a)',
  Fleet_Phase1_Select_vehicle_eTyy: 'Selecionar carro',
  Fleet_Phase1_Weekly_rent_Qcao: 'Taxa de locação semanal',
  Fleet_NewPaymentFlow_sKlJ_uHRX: 'Cobrança {{num}}',
  Fleet_Phase2_Accept_the_SSyv: 'Convite aceito',
  Fleet_Phase1_Upload_vehicle_CJxH: 'Envie as fotos do carro',
  Fleet_Phase3_Insurance_UelD: 'Taxa de seguro',
  Fleet_Phase1_Open_positioning_isUK: 'Essa ativação permitirá que você visualize mais informações',
  Fleet_Phase3_Delete_isuY: 'Deletar',
  Fleet_Phase3_Select_city_OuhR: 'Selecione uma cidade',
  Fleet_Phase1_No_somg: 'Não',
  Fleet_Phase2__picture_dcAZ: '[Imagem]',
  Fleet_NewPaymentFlow__aQyj: 'Adicionar cobranças',
  Fleet_Phase2_Can_t_Ypzr: 'A mensagem está em branco',
  Fleet_Phase1_Lease_Information_AcRo: 'Informações da locação',
  Fleet_Phase2_Fill_in_HjMn:
    'Preencha os detalhes do seu currículo para a frota conhecer você melhor',
  Fleet_Phase1_Electric_OCNq: 'Elétrico',
  Fleet_Phase1_Confirmation_hXpq: 'Confirmar',
  Fleet_Phase3__ZyyO: 'Tem certeza que deseja sair?',
  Fleet_Phase3__ZGux: 'Baixar aplicativo {{brand_name}}',
  Fleet_Phase1_Go_on_lQWv: 'Permitir agora',
  Fleet_Phase2_Are_you_tmbn: 'Deseja realmente aceitar o convite?',
  Fleet_0303_Fleet_WorkRegime_Car_front_XMgw:
    'Recompensa ao motorista parceiro paga pelo dono da frota',
  Fleet_Phase2_Upon_acceptance_RppA:
    'Se aceitar, você vai entrar na frota e vincular este carro. Para sair, fale com a frota.',
  Fleet_Phase1_Display_MPQk: 'Exibições',
  Fleet_Phase2_Send_your_boUl: 'Enviar currículo',
  Fleet_NewPaymentFlow__upZL: 'Tipo de cobrança',
  Fleet_Phase3_Agree_GpZc: 'Atender',
  Fleet_Phase2_Are_you_pyUy:
    'Deseja mesmo bloquear o(a) motorista? Se fizer isso, você não receberá mais as mensagens dele(a)',
  Fleet_Phase1_Location_hZax: 'Localização',
  Fleet_Phase1_My_resume_XrBM: 'Meu currículo',
  Fleet_NewPaymentFlow__ZwVw: 'As despesas entrarão em vigor a partir de {{Effective_date}}',
  Fleet_Phase1_Introduce_more_wgzd:
    'Adicione mais informações sobre o carro para alugá-lo mais rápido',
  Fleet_Phase2_Unable_to_BjVG: 'Não foi possível aceitar o convite. Outra frota já convidou você',
  Fleet_Phase1_Boleto_FURd: 'Boleto',
  Fleet_NewPaymentFlow_CAbk_WnqE:
    'O aluguel e outras cobranças serão recebidas automaticamente da Carteira 99 do motorista. Se a Carteira não tiver saldo suficiente, você precisará cobrar o restante do motorista manualmente',
  Fleet_Phase3__wuiT: 'Cancelar',
  Fleet_Phase3__cGjU: 'Enviar',
  Fleet_Phase2_Latin_America_mcWa: 'Bloquear',
  Fleet_Phase1_Open_the_qftm:
    'Em Configurações>Privacidade>Notificações, permita que a frota {{app_name}} envie notificações',
  Fleet_Mgt_Loosen_immediately_OZaY: 'Solte para atualizar',
  Fleet_Phase2_The_invitation_cRjb:
    'Convite expirado. Peça à frota para mandar o link de convite de novo',
  Fleet_MatchingTool_New_NygE: 'Novo',
  Fleet_Phase2_Message_uxVI: 'Mensagens',
  Fleet_Phase1_Mileage_Nbsu: 'Quilometragem atual do veículo',
  Fleet_Phase1_Select_a_MUGc: 'Selecione a cidade',
  Fleet_Phase3__aLzi: 'Pesquisar nº da placa/modelo',
  Fleet_Phase3_Disapproval_WwYC: 'Recusar',
  Fleet_Phase1_Saved_ukpW: 'Favorito',
  Fleet_Phase1_Near_GlZf: 'Por perto',
  Fleet_Phase1_Fill_in_SDNM: 'Preencher agora',
  Fleet_NewPaymentFlow__GiSP: 'Data de ativação',
  Fleet_0303_Fleet_WorkRegime_Rental_fares_pUsF: 'Locação de veículo',
  Fleet_Phase2_Camera_xPcX: 'Câmera',
  Fleet_Phase1_Contact_the_sCYy: 'Contatar motorista',
  Fleet_Phase1__trip_OWdz: '{{trip_num}} corrida(s)',
  Fleet_Phase3_Set_ozBm: 'Configurações',
  Fleet_Phase1_Vehicles_fail_vWFT:
    'Não foi possível adicionar veículo. Tente novamente mais tarde.',
  Fleet_Phase1_Credit_card_nkHX: 'Cartão de crédito',
  Fleet_replenish__YWZk: 'Apelido da frota',
  Fleet_NewPaymentFlow__vurJ:
    'Aluguel e outras despesas serão deduzidas automaticamente de sua Carteira 99. Se o seu saldo for insuficiente, você precisará pagar o restante ao(a) locador(a)',
  Fleet_Phase1_Vehicle_mileage_JJmR: 'Quilometragem do carro',
  Fleet_Phase2_I_m_otcY: 'Tenho interesse no seu carro. Podemos conversar sobre isso?',
  Fleet_deactivation_vcXF_nzJK: 'Estes carros foram removidos',
  Fleet_NewPaymentFlow__ltIu:
    'O aluguel e outras cobranças serão recebidas automaticamente da Carteira 99 do motorista. Se a Carteira não tiver saldo suficiente, você precisará cobrar o restante do motorista manualmente',
  Fleet_NewPaymentFlow__cGLW:
    'Observe que após aceitar este convite, o(a) locador(a) poderá adicionar ou editar uma despesa sem sua confirmação. Você será informado sobre estas movimentações.',
  Fleet_Phase3_Contact_number_gTtI: 'Número para contato',
  Fleet_Drivers_Amount_YOtw: 'Valor',
  Fleet_Phase3_Urban_upMp: 'Cidade',
  Fleet_NewPaymentFlow__wclB:
    'Leia e confirme o aluguel e outras despesas. Toque em Aceitar para iniciar a vigência',
  Fleet_Phase1_Select_the_DRmS: 'Selecione um tipo de câmbio',
  Fleet_Phase2_Album_HNuC: 'Álbum',
  Fleet_Phase3_Would_you_XJNH: 'Tem certeza de que deseja excluir este endereço?',
  Fleet_Phase3__wCFx: 'Enviado',
  Fleet_Phase1_Reset_ZyNB: 'Redefinir',
  Fleet_NewPaymentFlow__BFLZ: 'OK',
  Fleet_Phase1_Edit_IQWQ: 'Editar',
  Fleet_Phase1_Browse_HIWC: 'Acessos',
  Fleet_Phase1_Payment_Method_fVJF: 'Método de pagamento preferencial',
  Fleet_Phase1_Click_Change_LCrQ: 'Toque para alterar',
  Fleet_Phase3_Cancel_flmb: 'Cancelar',
  Fleet_NewPaymentFlow_OSHq_PQkz: 'Selecione um carro',
  Fleet_replenish__dJdA: 'Erro no sistema. Tente novamente',
  Fleet_Phase1_Next_step_OMuQ: 'Próximo',
  Fleet_NewPaymentFlow__ydGV: 'Informações da locação',
  Fleet_Phase1_Star_rating_jYxN: 'Avaliação',
  Fleet_Phase2_Unable_to_ylbx: 'Não foi possível aceitar o convite. O carro já expirou',
  Fleet_Phase2_Confirmation_JNjK: 'Confirmar',
  Fleet_Phase1_Payment_Method_wZPV: 'Método de pagamento',
  Fleet_replenish__ZOFV: 'Não foi possível fazer a chamada. Tente novamente',
  Fleet_Phase3_Other_jpBw: 'Outros',
  Fleet_Phase1_Unable_to_LSII: 'Não foi possível obter permissão de notificação',
  Fleet_Phase1_Model_tdll: 'Modelo',
  Fleet_NewPaymentFlow__yzdB: 'Detalhes do carro',
  Fleet_Phase3_Unable_to_pVKf: 'Não foi possível fazer a chamada. Tente novamente',
  Fleet_Phase3_Set_to_rSJK: 'Definir end. de retirada padrão',
  Fleet_Phase1_Add_your_cKWv: 'Mostre seu veículo para motoristas que gostariam de alugar um',
  Fleet_Phase3__CXxw: 'Serviços de localização desativados',
  Fleet_Phase2_View_Details_MBZa: 'Ver detalhes',
  Fleet_Phase1_Type_of_YmjW: 'Tipo de combustível',
  Fleet_Phase3__gvnI: 'Sem resultados',
  Fleet_NewPaymentFlow__QXtF: 'Mensal',
  Fleet_Mgt_No_more_mlms: 'Fim dos resultados',
  Fleet_Phase1_Successful_shelves_roWu: 'Adicionado com sucesso',
  Fleet_Phase2_Unable_to_UqWk:
    'Não foi possível enviar o convite. Outra frota já adicionou o(a) motorista',
  Fleet_Phase1_Weekly_online_gZHC: 'Horas conectado por semana',
  Fleet_Phase2_Accept_the_RiKY: 'Aceitar convite',
  Fleet_FleetRecommendation_Contact_number_yTBC: 'Número de contato',
  Fleet_Phase3_Public_number_KRCc: 'Exibir meu número',
  Fleet_Phase1_Introduce_more_WZRj: 'Conte para a Frota um pouco mais sobre você',
  Fleet_Phase1_Add_a_QLhS: 'Adicionar currículo',
  Fleet_Phase1_Refresh_iWvD: 'Atualizar',
  Fleet_Phase1_Enter_the_LXDS: 'Insira seu nome',
  Fleet_Phase1_Go_and_ddqt: 'Entrar agora',
  Fleet_deactivation_pIlV_dzGd: 'Este carro será removido em breve',
  Fleet_Phase3__XowH: 'Tem certeza de que deseja enviar este e-mail?',
  Fleet_Phase3__Gfwg: 'Enviando',
  Fleet_Phase1_Hand_gear_hAFe: 'Manual',
  Fleet_NewPaymentFlow__PRyq: 'Diária',
  Fleet_Phase1_Enter_the_tbQJ: 'Insira um valor',
  Fleet_Phase2_Contact_the_xIkV: 'Contatar dono da frota',
  Fleet_Phase2_Action_ZSsi: 'Escolha uma opção',
  Fleet_NewPaymentFlow__Khbs: 'Automático',
  Fleet_Phase1_Diesel_rsEa: 'Diesel',
  Fleet_Phase2_Call_yqck: 'Ligar',
  Fleet_Phase1_Other_tQVW: 'Outros',
  Fleet_Phase1_Collection_XqMI: 'Favorito',
  Fleet_Phase1_Personal_information_rOpp: 'Informações pessoais',
  Fleet_Phase1_Default_image_AFLD: 'Imagens padrão',
  Fleet_Phase1_Vehicle_photos_CWvR: 'Fotos do carro',
  Fleet_Phase1_Add_more_ykcL: 'Adicione mais informações sobre o carro para alugá-lo mais rápido',
  Fleet_Drivers_Save_feyd: 'Salvar',
  Fleet_Phase1_Go_vwbQ: 'Ir',
  Fleet_Phase2_Send_UCas: 'Enviar',
  Fleet_Phase3_Offences_Eyzh: 'Taxa de violação de trânsito',
  Fleet_Phase1_Price_JEDD: 'Preço',
  Fleet_Phase1_Confirmation_and_UFnR: 'Confirmar e adicionar',
  Fleet_Phase1_Add_a_yEOo: 'Adicione fotos do carro para alugar seu carro mais rápido',
  Fleet_Phase2_Waiting_for_PGxV: 'Aguardando resposta',
  Fleet_Phase1_Select_model_MskT: 'Selecione um tipo de veículo',
  Fleet_Phase3_Pick_up_fDQC: 'Endereço de retirada do carro',
  Fleet_Phase2_Your_vehicle_etii:
    '{{Vehicle_Plate}} não foi aprovado. Envie as informações necessárias e adicione de novo',
  Fleet_Phase2_Select_vehicle_DmgM: 'Selecionar um carro',
  Fleet_Phase2_Don_t_fbDU: 'Não quer perder mensagens ou novidades?',
  Fleet_Phase3__yPol: 'Os motoristas não veem seu endereço completo',
  Fleet_Phase3_Show_Name_DTSP: 'Nome exibido',
  Fleet_Phase1_Rental_gIKm: 'Tarifa da locação',
  Fleet_Phase1_No_idle_CWLj: 'Não há carros disponíveis',
  Fleet_Phase2_I_think_iJfP: 'Acho que meu carro seria ideal para você. Podemos falar sobre isso?',
  Fleet_Phase1_Cancel_the_jVMw: 'Removido dos favoritos',
  Fleet_Phase1_Week_DoYO: 'semana',
  Fleet_0303_Fleet_WorkRegime_Driver_Recharge_jdnd: 'Recarga do motorista parceiro',
  Fleet_NewPaymentFlow__bEhi:
    'O aluguel e outras despesas serão pagas automaticamente através da Carteira 99',
  Fleet_NewPaymentFlow_kWOv_gcBa: 'Selecione',
  Fleet_deactivation_IDBa_Nsnf: 'Este carro foi removido',
  Fleet_v2_Successfully_saved_SuWc: 'Salvo com sucesso',
  Fleet_Phase1_Transmission_box_ntTQ: 'Câmbio',
  Fleet_Phase1_Select_Energy_jPEr: 'Selecione o tipo de energia',
  Fleet_Phase1_shelves_gQRG: 'Disponibilizar',
  Fleet_FleetRecommendation_Enter_the_OAao: 'Insira um número de telefone válido',
  Fleet_NewPaymentFlow__EBXA:
    'Cobrança manual: você precisará pagar o aluguel e outras despesas ao(a) locador(a) manualmente',
  Fleet_NewPaymentFlow__xLMz:
    'O aluguel e outras despesas deverão ser pagas manualmente ao(a) locador(a)',
  Fleet_Phase2_Invitation_to_XuMK: 'Convidar',
  Fleet_Phase1_Delete_vHOi: 'Deletar',
  Fleet_Phase2__CV_ufBg: '[Currículo]',
  Fleet_Phase1_The_vehicle_iveG: 'Veículo já vinculado a um motorista. Desvincule e tente de novo',
  Fleet_Phase3_No_pickup_yaXi: 'Nenhum endereço fornecido',
  Fleet_Phase2_Get_a_ViuM: 'Ver currículo',
  Fleet_Phase1_Star_rating_LMKh: 'Avaliação',
  Fleet_NewPaymentFlow__TGeN: 'Método de cobrança de despesas',
  Fleet_0303_Fleet_WorkRegime_drawn_front_MIbK: '0% de cobrança no cartão de comissão da frota',
  Fleet_Phase1_Energy_PPWp: 'Energia',
  Fleet_Phase1_More_information_QGAV: 'Mais informações',
  Fleet_Phase2_Unable_to_Mpfg: 'Não foi possível enviar o convite. O(A) motorista foi suspenso(a)',
  Fleet_Phase1_Exit_olZc: 'Sair',
  Fleet_Phase1_Other_ydLJ: 'Outros',
  Fleet_Phase2_All_BQZQ: 'Todos',
  Fleet_Phase1_Please_select_XUaB: 'Selecione os serviços disponíveis',
  Fleet_Phase3_Call_now_MEMz: 'Ligar agora',
  Fleet_Phase2_Your_vehicle_Rmil: 'Seu carro {{Vehicle_Plate}} foi adicionado',
  Fleet_Phase1_Home_Page_ezjA: 'Carteira',
  Fleet_Phase2_Are_you_uNIJ: 'Deseja mesmo remover o chat da lista?',
  Fleet_0303_Fleet_WorkRegime_Car_wash_XdSy: 'Taxa de limpeza',
  Fleet_Phase1__One_ZBrR: '(taxa única)',
  Fleet_Phase1_It_s_wzyX: 'Não há mais dados',
  Fleet_Phase3__cYdF: 'Ir para análise de documentos',
  Fleet_Phase1_The_vehicle_cZTB: 'Veículo removido. Adicione-o novamente',
  Fleet_Phase1_Take_a_SlkQ: 'Tirar foto',
  Fleet_report_Division_Information_capz: 'Informações do motorista',
  Fleet_NewPaymentFlow__OEob:
    '{{Expenses_type}} será deduzido de sua Carteira 99 com um pagamento único',
  Fleet_Phase3_Hidden_Number_tNmI: 'Ocultar meu número',
  Fleet_Phase1_My_message_SfLZ: 'Minhas informações',
  Fleet_Phase3__jxmA: 'Endereço de e-mail',
  Fleet_NewPaymentFlow__BevI: 'Semanal',
  Fleet_Phase2_I_invite_jgxW: 'Convidei você para minha frota',
  Fleet_Phase1_Mixed_aWEq: 'Híbrido',
  Fleet_0303_Fleet_WorkRegime_Other_items_zPbu: 'Outros',
  Fleet_0303_Fleet_WorkRegime_Oil_PGEr: 'Taxa de reabastecimento',
  Fleet_Phase2__Fleet_RTrK: '{{Fleet_Name}} convidou você para a frota',
  Fleet_Phase1_Upload_your_NZFc: 'Envie os documentos do veículo',
  Fleet_0303_Fleet_WorkRegime_lease_fee_hIok: 'Aluguel de telefone',
  Fleet_Phase3__xZGP: 'Resultado da análise',
  Fleet_Phase2__Vehicle_mAIO: '[Carro {{Vehicle_Model}}]',
  Fleet_Phase3__lTOd: 'Os documentos não foram enviados ou aprovados na análise',
  Fleet_Phase1_The_driver_pCZd:
    'Os motoristas podem falar diretamente com você nesse endereço de e-mail',
  Fleet_Phase3_User_Services_wNXe: 'Termos de Uso',
  Fleet_NewPaymentFlow__tgtT: 'Aluguel',
  Fleet_Phase3_GNV_amUx: 'GNV',
  Fleet_Phase3_Integrated_sorting_uksd: '',
  Fleet_Phase3_Deposit_TMrZ: 'Depósito',
  Fleet_NewPaymentFlow_mzMZ_ChLK: 'Insira',
  Fleet_Drivers_Go_Settings_vpjg: 'Configurações',
  Fleet_Phase2_Open_notification_kirV: 'Permita as notificações para receber mensagens e novidades',
  Fleet_Phase1_Message_iuXA: 'Mensagens',
  Fleet_Phase2_Unable_to_jWPV:
    'Não foi possível aceitar o convite. Faça a análise dos documentos antes',
  Fleet_Phase1_Year_uoao: 'ano(s)',
  Fleet_Phase1_Cancel_JTqC: 'Cancelar',
  Fleet_Phase3_Unable_to_nWie: 'Não é possível adicionar',
  Fleet_Phase1_Idle_GiMD: 'Tempo inativo',
  Fleet_Phase3__LovJ: 'Sair',
  Fleet_Phase1_Oil_to_UJTc: 'Flex',
  Fleet_Phase1_You_can_zwFo: 'Você também pode adicionar carros ociosos',
  Fleet_Phase1_Single_amount_mreo: 'Corridas',
  Fleet_MatchingTool_Confirmation_sFAu: 'OK',
  Fleet_Phase3_Cost_type_DhmU: 'Tipo de taxa',
  Fleet_Phase1_Select_one_YoKe: 'Selecione uma opção',
  Fleet_NewPaymentFlow__BVvn: 'Manual',
  Fleet_Phase3_Coming_up_Vjsn: 'Esta chamada será criptografada',
  Fleet_MatchingTool_Cancel_Wqtt: 'Cancelar',
  Fleet_FMS_Verification_failed_dRqq: 'Não aprovado',
  Fleet_Phase2_Driver_Message_UxZf: 'Mensagens do(a) motorista',
  Fleet_Phase1_Mileage_in_vScJ: 'Quilometragem',
  Fleet_NewPaymentFlow__Mhyi: 'Deletar',
  vehicle_info: 'Informações do veículo',
  small: 'A imagem deve ter menos de 3 MB',
  Fleet_check_hceA_ycnc: 'Got It',
  Fleet_check_fBNK_CTjZ: 'You can only invite drivers after your profile photo is approved.',
  GDriver_Name_DiDi_Gsik: 'DiDi',
  Fleet_check_pajT_vPwq: 'Please Upload a Profile Photo',
  Fleet_tool_HivM_XeKG:
    'Please consider the reliability of information received from outside the {{brand_name}} platform and beware of false information.',
  Fleet_check_IYER_eDig:
    'You can only link vehicles to drivers in your fleet after your profile photo is approved.',
  Fleet_check_PFze_fown: 'Profile Photo Review in Progress',
  Fleet_check_OZWz_BEqb: 'Upload Now',
  Fleet_check_Admw_cABo: 'Not Now',
  Fleet_check_XKad_fPlI: 'Please Re-Upload Profile Photo',
  Fleet_check_uiYb_OxPW:
    'Your profile photo was declined {{reject_max_time}} times. To use this feature, please upload a valid photo and wait for approval.'
};
